module.exports = __webpack_public_path__ + "static/RAFAA_logo-05fb64744af7fc039673cc03d3426251.png";